import { Component } from '@angular/core';

@Component({
    selector: 'scaffold-layout-header',
    templateUrl: './layout-header.component.html',
    styleUrl: './layout-header.component.scss',
    standalone: false
})
export class LayoutHeaderComponent {}
